import React from 'react';
import {
  OccurrenceOuterCard,
  OccurrenceCardHeader,
  OccurrenceCardHeaderLeft,
  CqaText,
  SmallActivityCard,
  CardFirstRow,
  CardSecondRow,
  CardThirdRow,
  CardFourthRow,
  LineSeparetor,
  CardFifthRow,
  ExecPhoto,
  ExecPhotoWrapper,
  MoreExecContainer,
  StatusIcon,
} from '../shared/styled';
import { ReactComponent as BullhornIcon } from 'assets/icons/bullhorn_sm.svg';
import { ReactComponent as ExecutorNoPhotoIcon } from 'assets/icons/executor-no-photo-icon.svg';
import { CalendarEvent, EventColorSet } from 'pages/Agenda/utils';

const OCCURRENCE_BLUE = '#85BFE4';

interface OccurrenceEventCardProps {
  event: CalendarEvent;
  colorSet: EventColorSet;
  isCompletedView: boolean;
  onEventClick: (event: CalendarEvent, colorSet: EventColorSet) => void;
}

export const OccurrenceEventCard: React.FC<OccurrenceEventCardProps> = ({
  event,
  colorSet,
  isCompletedView,
  onEventClick,
}) => {
  const executorCount = event.executor?.length ?? 0;
  const firstExecutor = executorCount === 1 ? event.executor[0] : undefined;
  const displayExecutors = event.executor ? event.executor.slice(0, 3) : [];

  const solucionada = event.realizada || isCompletedView;

  // Dot de status: verde (solucionada) | vermelho (atrasada) | azul (pendente normal)
  const statusDotColor = solucionada ? '#4CAF50' : event.atrasada ? '#E74C3C' : OCCURRENCE_BLUE;
  const statusContent = solucionada ? '✓' : null;

  return (
    <OccurrenceOuterCard onClick={() => onEventClick(event, colorSet)}>
      {/* Header: [🔔 bullhorn azul] [CQA azul] ... [● status dot] */}
      <OccurrenceCardHeader>
        <OccurrenceCardHeaderLeft iconColor={OCCURRENCE_BLUE}>
          <BullhornIcon />
          <CqaText fontColor={OCCURRENCE_BLUE}>{event.numeroChamado}</CqaText>
        </OccurrenceCardHeaderLeft>
        <StatusIcon color={statusDotColor}>{statusContent}</StatusIcon>
      </OccurrenceCardHeader>

      {/* Card interno — versão menor do card de atividade */}
      <SmallActivityCard borderLeft={colorSet.borderColor} backgroundColor={colorSet.backgroundColor}>
        <CardFirstRow fontColor={colorSet.fontColor}>
          <span>
            {event.time} • {event.title}
          </span>
        </CardFirstRow>
        <CardSecondRow>{event.aplicacao}</CardSecondRow>
        <CardThirdRow>{[event.equipamento, event.equipamentoTag].filter(Boolean).join(' - ')}</CardThirdRow>
        <CardFourthRow>
          {executorCount === 1 && firstExecutor ? (
            <>
              {firstExecutor.avatar ? (
                <ExecPhoto src={firstExecutor.avatar} alt={firstExecutor.nome} />
              ) : (
                <ExecPhotoWrapper>
                  <ExecutorNoPhotoIcon width={20} height={20} />
                </ExecPhotoWrapper>
              )}
              <span
                style={{
                  marginLeft: '6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {firstExecutor.nome}
              </span>
            </>
          ) : executorCount > 1 ? (
            <MoreExecContainer>
              <div>
                {displayExecutors.map((exec, index) =>
                  exec.avatar ? (
                    <ExecPhoto
                      key={`exec-${exec.nome}-${index}`}
                      src={exec.avatar}
                      alt={exec.nome}
                      style={{ marginLeft: index === 0 ? 0 : -8, zIndex: index, position: 'relative' }}
                    />
                  ) : (
                    <ExecPhotoWrapper
                      key={`exec-${exec.nome}-${index}`}
                      style={{ marginLeft: index === 0 ? 0 : -8, zIndex: index, position: 'relative' }}
                    >
                      <ExecutorNoPhotoIcon width={20} height={20} />
                    </ExecPhotoWrapper>
                  ),
                )}
                <span>{executorCount} executores</span>
              </div>
            </MoreExecContainer>
          ) : null}
        </CardFourthRow>
        <LineSeparetor separetorColor={colorSet.separetorColor} />
        <CardFifthRow style={{ color: colorSet.fontColor }}>Ocorrência ({event.horasPrevistas})</CardFifthRow>
      </SmallActivityCard>
    </OccurrenceOuterCard>
  );
};
